import React, { Component } from 'react';
import { ScrollView, Animated, Easing, Dimensions, TouchableWithoutFeedback } from 'react-native';

import { map as _map, isEqual as _isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { VFText, Collapsible, BlinkView } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { getItemStatus, getDetailsStatusText } from '../Utils';

import Styles from './DetailsScreenStyles';
import ErrorItem from './EverytingIsOkErrorItem';

const { height: screenHight } = Dimensions.get('window');
const BLINK_RATE = 500;
class DetailsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 2,
      type: null,
      activeList: [],
    };
    this.animatedText = new Animated.Value(1);
  }
  componentDidMount() {
    const { init, data } = this.props;
    init && init();
    this.getEIOStatus(data);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.status !== this.state.status ||
      !_isEqual(prevProps.data, this.props.data) ||
      !this.state.type
    ) {
      this.getEIOStatus(this.props.data, prevState.activeList);
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.type && prevState.type !== this.state.type) {
      this.animatedText.setValue(0);
      this.animateVFText();
    }
    return null;
  }

  getItemContent = (list, onEIOActionPress, closeExpanding) => {
    const { type } = this.state;
    const onPress = item => onEIOActionPress(item, closeExpanding);
    return _map(list, (subItem, index) => {
      return (
        <ErrorItem
          onActionClick={onPress}
          {...subItem}
          isLastElement={index + 1 === list.length}
          type={type}
          index={index}
          key={`Error-Item-${subItem.title}-${index}`}
        />
      );
    });
  };

  getEIOStatus = (data, prevActiveList) => {
    let status = 0;
    const activeList = prevActiveList || [];
    if (!data.length) {
      status = 2;
    }
    data.forEach((item, index) => {
      const itemStatus = getItemStatus(item);
      if (itemStatus.status > status) {
        status = itemStatus.status;
      }
      if (itemStatus.isActive) {
        activeList.push(index + 1);
      }
    });
    this.setState({
      status,
      activeList,
      type: status === 0 ? 'primary' : 'secondary',
    });
  };
  handelBack = () => {
    const { onClose } = this.props;
    onClose();
  };
  formatData = data => {
    const { onEIOActionPress, icons, showDetailsIcons, closeExpanding } = this.props;
    const { type } = this.state;

    return _map(data, (item, index) => ({
      icon: showDetailsIcons ? icons[item.icon] : null,
      title: item.title,
      content: this.getItemContent(item.subItems, onEIOActionPress, closeExpanding),
      isBlinking: getItemStatus(item).status === 1 && this.state.status !== 2,
      status: getItemStatus(item).status,
      iconTestID: `${FrameworkTestKeys.DSIcon}${index}`,
      iconAccessibilityLabel: type,
    }));
  };
  animateVFText = () => {
    Animated.timing(this.animatedText, {
      toValue: 1,
      duration: 500,
      easing: Easing.linear,
      useNativeDriver: false,
    }).start();
  };
  render() {
    const { data = [], animationValue, showDetailsIcons, placeHolders } = this.props;
    const { type, activeList, status } = this.state;
    const translateY = this.animatedText.interpolate({
      inputRange: [0, 1],
      outputRange: [55, 0],
    });
    const opacity = this.animatedText.interpolate({
      inputRange: [0, 1],
      outputRange: [0, 1],
    });

    const viewOpacity = animationValue.interpolate({
      inputRange: [115, screenHight * 0.9, screenHight],
      outputRange: [0, 0, 1],
    });
    return (
      <Animated.View
        style={{ opacity: viewOpacity }}
        testID={FrameworkTestKeys.EIODetailsScreenAnimatedMainView}
      >
        <Animated.View
          style={[
            Styles.animatedViewStyle,
            {
              opacity: opacity,
              transform: [{ translateY }],
            },
          ]}
          testID={FrameworkTestKeys.EIODetailsScreenAnimatedView}
        >
          <BlinkView disabled={this.state.status !== 2} blinkRate={BLINK_RATE}>
            <VFText
              i18nKey={getDetailsStatusText(status)}
              placeHolders={placeHolders}
              type={type}
              style={Styles.statusText}
              testKey={FrameworkTestKeys.EIODetailsPageResult}
            />
          </BlinkView>
        </Animated.View>
        <ScrollView
          contentContainerStyle={Styles.scollViewContainer}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          testID={FrameworkTestKeys.EIODetailsScreenScrollView}
        >
          <TouchableWithoutFeedback testID={FrameworkTestKeys.EIODetailsScreenTWF}>
            <Collapsible
              items={this.formatData(data)}
              type={type}
              activeSections={showDetailsIcons ? activeList : []}
            />
          </TouchableWithoutFeedback>
        </ScrollView>
      </Animated.View>
    );
  }
}

DetailsScreen.defaultProps = {
  data: [],
  animationValue: { interpolate: () => {} },
  closeExpanding: () => {},
};

DetailsScreen.propTypes = {
  data: PropTypes.any,
  init: PropTypes.func,
  onClose: PropTypes.func,
  onEIOActionPress: PropTypes.func.isRequired,
  showDetailsIcons: PropTypes.bool,
  closeExpanding: PropTypes.func,
  icons: PropTypes.object,
  animationValue: PropTypes.object,
  placeHolders: PropTypes.arrayOf(PropTypes.string),
};

export default DetailsScreen;
